import { trace } from 'rytm-helpers'


const onDocumentScroll = (e) => {
  updateHEaderBg(window.scrollY)
}

const updateHEaderBg = (scrollY) => {
  if (scrollY < remToPx(9)) {
    const headerBg = document.querySelector(".header-full .header-bg")
    if (headerBg) {
      const myY = -scrollY * .5
      headerBg.style.transform = "translateY(" + myY + "px)"
    }
  }
}
const remToPx = (rem) => {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export const initWfHeader = () => {
  document.addEventListener("scroll", onDocumentScroll)
}
